import { render, staticRenderFns } from "./WameedPageHeader.vue?vue&type=template&id=2d8e78bf&"
import script from "./WameedPageHeader.vue?vue&type=script&lang=js&"
export * from "./WameedPageHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports